"use strict";

exports.__esModule = true;
exports.wrapPageElement = void 0;
var _LocalizationContext = require("./LocalizationContext");
var _getSharesightCountry = require("./getSharesightCountry");
var _locales = require("./locales");
var _getConsentCookie = require("./getConsentCookie");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Injects context into every single page.
 * Access like `const { … } = useLocalizationContext()`.
 */
function withLocalization(context) {
  return function WrappedWithLocalization(children) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocalizationContext.LocalizationContext.Provider, {
      value: context,
      children: children
    });
  };
}
var wrapPageElement = exports.wrapPageElement = function wrapPageElement(_ref, pluginOptions) {
  var element = _ref.element,
    props = _ref.props;
  /*
   * Some "Page Elements" aren't react, eg. Javascript files?
   * It's unclear, but this doesn't go boom.
   */
  if (!props) return null;
  var localization = props.pageContext.localization;
  var consentCookie = (0, _getConsentCookie.getConsentCookie)();
  var sharesightCountry = (0, _getSharesightCountry.getSharesightCountry)();
  var getCurrentLocale = function getCurrentLocale() {
    /*
     * this should pull from the pageContext's localization object if no consent cookie is present
     * if no consent cookie is present then the sharesight country cookie
     * will not be updated with the user's latest preferred locale
     */
    if (!consentCookie) return localization.currentLocale;
    if (consentCookie.performance && sharesightCountry) return sharesightCountry;
    return localization.currentLocale;
  };
  var currentLocale = getCurrentLocale();
  var siteLocales = localization.siteLocales || _locales.locales;
  var context = {
    // From pluginOptions
    excludePaths: pluginOptions.excludePaths,
    // This `pageContext.localization` comes from `createPage` (via `onCreatePage` or `createPages`).
    currentLocale: currentLocale || _locales.defaultLocale,
    availableLocales: localization.availableLocales || siteLocales,
    siteLocales: siteLocales,
    defaultLocale: localization.defaultLocale || _locales.defaultLocale,
    currentPath: localization.currentPath,
    basePath: localization.basePath
  };
  return withLocalization(context)(element);
};